<template>
  <div>
    <v-simple-table
      class="summary-footer"
      dense
    >
      <template v-slot:default>
        <thead />
        <tbody ref="refBody">
          <tr
            v-for="(item, index) in items"
            :key="index"
          >
            <td
              v-if="item.product"
              class="px-0"
            >
              <v-list-item
                dense
                class="px-0"
              >
                <v-list-item-icon class="me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-wrap"
                    @click="openProductEdit(item)"
                  >
                    {{ item.product.name }}{{ (item.product.code ? ' ( ' + item.product.code + ' ) ' : '') }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t('unit') }} : {{ (item.product.unit ? item.product.unit.fame : '') }}
                    | {{ $t('discount') }} {{ (item.discountPercent ? ' (' + item.discountPercent + '%) ' : '') }}: {{ $numberFormat(item.discount) }}
                    | {{ $t('tax') }} {{ (item.tax ? ' (' + item.taxPercent + '%) ' : '') }}: {{ $numberFormat(item.tax) }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div
                      style="text-decoration: underline;color:#7904f6;cursor: pointer"
                      @click="openProductEdit(item)"
                    >
                      {{ $t('editProductInformation') }}
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action
                  class="ma-1"
                >
                  <div class="d-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-show="scale"
                          v-bind="attrs"
                          :loading="loading"
                          small
                          color="blue"
                          class="me-1"
                          style="padding: 0px !important;min-width: 30px !important;"
                          @click="getItemWeight(item)"
                        >
                          <v-icon
                            dark
                          >
                            mdi-scale
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('getWeightScale') }}</span>
                    </v-tooltip>
                    <v-btn
                      small
                      color="primary"
                      class="me-1"
                      style="padding: 0px !important;min-width: 30px !important;"
                      @click="openNumpad(item)"
                    >
                      <v-icon
                        dark
                      >
                        mdi-calculator
                      </v-icon>
                    </v-btn>
                    <v-btn
                      small
                      color="green"
                      class=""
                      style="padding: 0px !important;min-width: 30px !important;"
                      @click="addCount(item)"
                    >
                      <v-icon
                        dark
                      >
                        mdi-plus
                      </v-icon>
                    </v-btn>
                    <v-text-field
                      v-model="item.count"
                      v-disabled-icon-focus
                      height="20"
                      dense
                      solo
                      hide-details
                      flat
                      class="dense"
                      :rules="[v => !!v || $t('is-required')]"
                      :background-color="($vuetify.theme.isDark ? '#1E1E1E' : '#e5e5e5')"
                      :placeholder="$t('count')"
                      type="number"
                      style="width: 75px"
                      @blur="zeroCountCheck(item)"
                      @input="checkCount(item)"
                      @focus="(item.count == 0 ? null : item.count)"
                    />
                    <v-btn
                      small
                      color="pink"
                      style="padding: 0px !important;min-width: 30px !important;padding-top: 2px"
                      class="me-1"
                      @click="minusCount(item)"
                    >
                      <v-icon
                        dark
                      >
                        mdi-minus
                      </v-icon>
                    </v-btn>
                    <money
                      v-model="item.fee"
                      :dense="true"
                      :outlined="true"
                      :label="$t('fee')"
                      :rules="[feeValidate]"
                      :solo="false"
                      :clearable="false"
                      style="width: 130px"
                      value-when-is-empty=""
                      :options="options"
                      class="mb-3 dense"
                      :disabled="((type == 'sell' || type == 'presale') && $store.state.allConfig && $store.state.allConfig.userInt && $store.state.allConfig.userInt.deactiveChangeSellPrice == 'active' ? true : false)"
                      @input="calcSum"
                    />
                  </div>
                  <!--                <div class="d-flex">-->
                  <!--                  <div-->
                  <!--                    class="mt-1 me-1 pa-1"-->
                  <!--                    style="height:29px;width: 149px;background-color: #d2d2d2;border-radius: 5px;padding-top: 6px !important;"-->
                  <!--                  >-->
                  <!--                    {{ $t('discount') }} {{(item.discountPercent ? ' ( ' + item.discountPercent + '% ) ' : '')}}: {{ $numberFormat(item.discount) }}-->
                  <!--                  </div>-->
                  <!--                  <div-->
                  <!--                    class="mt-1 me-0 pa-1"-->
                  <!--                    style="height:29px;width: 149px;background-color: #d2d2d2;border-radius: 5px;padding-top: 6px !important;"-->
                  <!--                  >-->
                  <!--                    {{ $t('tax') }} {{(item.tax ? ' ( ' + item.taxPercent + ' ) ' : '')}}: {{ $numberFormat(item.tax) }}-->
                  <!--                  </div>-->
                  <!--                </div>-->
                  <div class="d-flex">
                    <div
                      class="mt-1 me-1 pa-1"
                      style="height:29px;width: 268px;background-color: #9ee1ff;border-radius: 5px;padding-top: 6px !important;font-weight: bold"
                    >
                      {{ $t('sum') }}: {{ $numberFormat((parseFloat(item.fee) * parseFloat(item.count) + parseFloat((isNaN(item.tax) ? 0 : item.tax)) - parseFloat(item.discount)).toFixed(decimal)) }}
                    </div>
                    <v-btn
                      small
                      color="pink"
                      style="padding: 0px !important;min-width: 30px !important;padding-top: 2px"
                      class="mt-1"
                      outlined
                      @click="remove(item)"
                    >
                      <v-icon
                        dark
                      >
                        mdi-trash-can-outline
                      </v-icon>
                    </v-btn>
                  </div>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-dialog
      v-model="numpadDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="325"
    >
      <v-card style="background-color: #e3e3e3">
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="numpadDialog = false"
          >
            <v-icon
              class="close-hover"
              large
              color="grey"
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-1 mx-0 mt-0"
          >
            <numpad
              :input="numpadValue"
              @save="setNumpad"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <product-dialog
      v-model="showProductDialog"
      :item="selectedItem"
      @setItem="setEditItem"
    />
  </div>
</template>

<script>
  import General from '@/Mixins/general'
  export default {
    name: 'IndexCategoryItems',
    components: {
      numpad: () => import('../../../components/general/numpad/index.vue'),
    },
    mixins: [General],
    props: ['itemsProp', 'decimal', 'currency', 'type', 'offline', 'scale', 'weight'],
    data () {
      return {
        items: [],
        numpadDialog: false,
        loading: false,
        selectedItem: null,
        selectedItemNumpad: null,
        showProductDialog: false,
        isLoading: false,
        numpadValue: 0,
        timer: 0,
        appendTimer: 0,
      }
    },
    watch: {
      itemsProp (val) {
        this.items = val
      },
      decimal () {},
      currency () {},
      type () {},
      offline () {},
      showProductDialog (val) {
        if (val) {
          this.$store.commit('SET_AUTOFOCUS', false)
        } else {
          this.$store.commit('SET_AUTOFOCUS', true)
          this.$emit('setinputFocus')
        }
      },
      items: {
        handler () {
          this.$emit('input', this.items)
          this.$emit('callrefbodyhight', this.$refs.refBody.scrollHeight)
        },
        deep: true,
      },
      scale (val) {
        if (val && val === 'active') {
          // this.getWeight()
        } else {
          // this.stopWeight()
        }
      },
    },
    mounted () {
      if (this.itemsProp) {
        this.items = this.itemsProp
      }
    },
    methods: {
      setEditItem (item) {
        this.selectedItem.product = item
        this.selectedItem.fee = item.price
        this.selectedItem.discountPercent = item.discount_percent
        this.selectedItem.taxPercent = item.tax_percent
        this.calcSum()
      },
      openProductEdit (item) {
        this.selectedItem = item
        this.showProductDialog = true
      },
      feeValidate (value) {
        if (!value || parseFloat(value) <= 0) {
          return true
          // if (this.showProductDialog) {
          //   return true
          // } else {
          //   return this.$t('is-required')
          // }
        } else {
          return true
        }
      },
      openNumpad (item) {
        this.selectedItemNumpad = item
        this.numpadValue = item.count
        this.numpadDialog = true
      },
      setNumpad (data) {
        this.numpadDialog = false
        this.selectedItemNumpad.count = data
      },
      remove (item) {
        var i = this.items.indexOf(item)
        this.items.splice(i, 1)
        this.calcSum()
      },
      addCount (item) {
        item.count++
        var app = this
        clearTimeout(this.appendTimer)
        this.appendTimer = setTimeout(function () {
          app.calcSum()
        }, 100)
      },
      minusCount (item) {
        item.count--
        var app = this
        clearTimeout(this.appendTimer)
        this.appendTimer = setTimeout(function () {
          app.calcSum()
        }, 100)
      },
      zeroCountCheck (item) {
        if (parseFloat(item.count) === 0) {
          item.count = 1
          this.checkCount(item)
        }
      },
      checkCount (item) {
        if (!this.offline && (this.type === 'sell' || this.type === 'presale' || this.type === 'returnPurchase')) {
          var productStock = (item.product && item.product.stock ? parseFloat(item.product.stock.count) : 0)
          if (item.product && item.product.type === 'product' && this.$store.state.negative_inventory === 'no' && parseFloat(item.count) > productStock + parseFloat((this.$route.name !== 'presaleEdit' ? item.countEdit : 0))) {
            this.snakbarText = this.$t('alert-inventory-is-not-enough')
            this.snakbarColor = 'pink'
            this.snakbar = true
          } else {
            if (this.$route.name !== 'presaleEdit' && item.product && !item.product.price) {
              if (this.type === 'sell' || this.type === 'presale') {
                this.getPrice(item)
              }
            }
          }
        }
        this.calcSum()
      },
      getPrice (item) {
        var app = this
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.$axios.get(app.$endpoint + 'getdetail', {
            params: {
              select: 'getPrice',
              currency_id: app.currency.id,
              count: item.count,
              product_id: item.product.id,
              category_id: (app.account && app.account.category_id ? app.account.category_id : -1),
            },
          })
            .then(res => {
              res = res.data
              if (res.price > 0) {
                item.fee = res.price
              } else {
                item.fee = 0
              }
              if (item.fee > 0 && item.count > 0) {
                if (res.discount.amount) {
                  item.discount = res.discount.amount
                }
                if (res.discount.percent && parseFloat(res.discount.percent) > 0) {
                  var discount = (parseFloat(item.fee) * parseFloat(item.count)) * (parseFloat(res.discount.percent) / 100)
                  item.discount = discount
                }
              }
              app.calcSum()
            })
            .catch(err => {
              app.serverErrorHandeler(err)
            })
            .finally(() => (app.isLoading = false))
        }, 500)
        this.loading = false
      },
      calcSum () {
        this.$emit('calc')
      },
      getItemWeight (item) {
        item.count = parseFloat(this.weight)
      },
      // async getWeight () {
      //   var app = this
      //   const socket = new WebSocket('ws://localhost:4022/Scale')
      //   socket.onopen = function (event) {
      //     socket.send('connect')
      //     socket.send('getweight')
      //   }
      //   socket.onmessage = function (event) {
      //     if (event.data !== 'Error in getting weight' && event.data !== 'Thread Started' && event.data !== 'True') {
      //       app.weight = event.data
      //     }
      //   }
      // },
      // stopWeight () {
      //   const socket = new WebSocket('ws://localhost:4022/Scale')
      //   socket.onopen = function (event) {
      //     // socket.send('connect')
      //     socket.send('stopweight')
      //   }
      //   socket.onmessage = function (event) {
      //   }
      // },
    },
  }
</script>

<style scoped>

</style>
